module.exports = __webpack_public_path__ + "img/th-list-solid.17d856e2.svg";